import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Calendar, Tag, ChevronRight, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || "";

const CATEGORIES = [
  { value: '', label: 'Todos' },
  { value: 'trabajadores', label: 'Para trabajadores' },
  { value: 'legal', label: 'Legal' },
  { value: 'prl', label: 'PRL' },
  { value: 'normativa', label: 'Normativa' },
];

export default function BlogPage() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    axios.get(`${API_URL}/api/articles`).then(res => {
      setArticles(res.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const filtered = filter ? articles.filter(a => a.categoria === filter) : articles;

  return (
    <div className="min-h-screen bg-slate-50" data-testid="blog-page">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-slate-600 hover:text-slate-900">
            <ArrowLeft size={18} />
            <span className="text-sm">Inicio</span>
          </Link>
          <Link to="/">
            <img src="https://customer-assets.emergentagent.com/job_baja-laboral-riesgos/artifacts/m7tg5pgh_logo.jpg" alt="Logo" className="h-10 w-auto" />
          </Link>
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-6 py-12">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-rose-600">Blog</span>
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3" data-testid="blog-title">Conocimiento especializado en PRL</h1>
        <p className="mt-3 text-slate-600 max-w-2xl">Artículos sobre prevención de riesgos laborales, reincorporaciones y normativa vigente.</p>

        {/* Category filter */}
        <div className="flex flex-wrap gap-2 mt-8 mb-10" data-testid="blog-filters">
          {CATEGORIES.map(c => (
            <button
              key={c.value}
              onClick={() => setFilter(c.value)}
              className={`px-4 py-2 text-sm font-medium border transition ${filter === c.value ? 'bg-slate-900 text-white border-slate-900' : 'bg-white text-slate-600 border-slate-200 hover:border-slate-400'}`}
              data-testid={`filter-${c.value || 'all'}`}
            >
              {c.label}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="flex justify-center py-20"><Loader2 className="animate-spin text-rose-600" size={32} /></div>
        ) : filtered.length === 0 ? (
          <p className="text-slate-500 py-20 text-center">No hay artículos en esta categoría.</p>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filtered.map(article => (
              <Link to={`/blog/${article.slug}`} key={article.id} className="group" data-testid={`blog-card-${article.slug}`}>
                <div className="bg-white border border-slate-200 overflow-hidden hover:border-slate-400 transition">
                  <div className="h-48 overflow-hidden">
                    <img src={article.imagen} alt={article.titulo} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-[10px] font-bold uppercase tracking-wider text-rose-600 flex items-center gap-1">
                        <Tag size={10} />{article.categoria}
                      </span>
                      {article.created_at && (
                        <span className="text-[10px] text-slate-400 flex items-center gap-1">
                          <Calendar size={10} />
                          {new Date(article.created_at).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' })}
                        </span>
                      )}
                    </div>
                    <h2 className="font-bold text-slate-900 line-clamp-2 group-hover:text-rose-600 transition">{article.titulo}</h2>
                    <p className="mt-2 text-sm text-slate-500 line-clamp-3">{article.resumen}</p>
                    <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-slate-900 group-hover:text-rose-600 transition">
                      Leer artículo <ChevronRight size={16} />
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
